export default __webpack_public_path__ + "static/media/amazonwhite.37a76527.jpg";